export interface NotificationsSummary {
    totalUnread: number;
    totalHighPriority: number;
    totalCritical: number;
    lastNotificationDate: string | null;
    recentNotifications: NotificationItem[];
}

export interface NotificationsSummaryResponse {
    data: NotificationsSummary;
    errors: string[];
    warnings: string[];
    success: boolean;
    isFailure: boolean;
    hasWarnings: boolean;
}

/** Nested task history row from the notifications `task` object. */
export interface NotificationTaskHistoryItem {
    id: number;
    status: number;
    notes?: string | null;
    createdBy?: number | null;
    createdByUserName?: string | null;
    createdAt: string;
}

/** Nested task on a notification. View / Go to Task use this object when present. */
export interface NotificationTask {
    id: number;
    operationKey?: string | null;
    payload?: Record<string, unknown> | null;
    entityType?: string | null;
    entityId?: number | null;
    title?: string | null;
    description?: string | null;
    priority?: number | null;
    status?: number | null;
    dueDate?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    createdByName?: string | null;
    takenByName?: string | null;
    isAssignedToMe?: boolean | null;
    isCreatedByMe?: boolean | null;
    isInProgressByMe?: boolean | null;
    availableActions?: {
        canApprove?: boolean;
        canReject?: boolean;
        canComplete?: boolean;
    } | null;
    history?: NotificationTaskHistoryItem[] | null;
}

export interface NotificationItem {
    id: number;
    userId: number;
    userRole?: number;
    type?: number;
    priority: number;
    title: string;
    message: string;
    actionUrl: string | null;
    expiresAt: string | null;
    isRead: boolean;
    status: number;
    createdAt: string;
    updatedAt: string;
    readAt: string | null;
    dismissedAt: string | null;
    isExpired: boolean;
    /** @deprecated Prefer `task.id` when the nested task object is present. */
    taskId?: number | null;
    /** Present only for task-related notifications; drives Go to Task navigation. */
    task?: NotificationTask | null;
}

export enum NotificationPriority {
    LOW = 0,
    MEDIUM = 1,
    HIGH = 2,
    CRITICAL = 3
}

export enum NotificationStatus {
    UNREAD = 0,
    READ = 1,
    DISMISSED = 2,
    ARCHIVED = 3
}

export interface NotificationsListFilters {
    status?: NotificationStatus | null;
}
